import React, { useEffect, useState } from 'react';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { useHookstate } from '@hookstate/core';
import { DeviceTypeResponse } from './interface';
import { getDevicesType } from './service';

interface FilterAutocompleteDeviceTypeProps {
    readonly onDeviceTypeChange: (value: number | null) => void;
    readonly deviceTypeId?: number | null
    readonly groupDispatchs?: readonly number[]
    readonly disabled?: boolean
}

export default function FilterAutocompleteDeviceType({ disabled, onDeviceTypeChange, deviceTypeId }: FilterAutocompleteDeviceTypeProps) {
    const { translate } = useLang();
    const [options, setOptions] = useState<readonly DeviceTypeResponse[]>([]);
    const [value, setValue] = useState<DeviceTypeResponse | null>(null);
    const loading = useHookstate(false);

    useEffect(() => {
        getDevicesType().then(devicesType => {
            setOptions(devicesType)
            setValue(null)
        })
    }, [])

    useEffect(() => {
        if (!deviceTypeId) {
            setValue(null)
        }

    }, [deviceTypeId])

    return (
        <FormControl fullWidth size='small' >
            <Autocomplete
                id='filter-device-type'
                options={options}
                disabled={disabled}
                value={value}
                noOptionsText={translate('No options')}
                clearText={translate('Clear')}
                size='small'
                loading={loading.get()}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name ?? ''}
                onChange={(_, type) => {
                    setValue(type)
                    onDeviceTypeChange(type?.id ?? null)
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate('Device Type')}
                    />
                )}
            />
        </FormControl>
    )
}